import { Questions } from '@/features/questions-page/Questions/ui/Questions.jsx'
import './ui/Questions.scss'
export default Questions
